import React from "react";
import LocationItem from "./LocationItem";
import {Link} from "react-router";
import {styled} from "@mui/material/styles";

const LocationItemLinkStyles = styled(Link)(() => ({
  '&:link': {
    textDecoration: 'none',
  },
  '&:visited': {
    textDecoration: 'none',
  },
  '&:focus': {
    textDecoration: 'none',
  },
  '&:hover': {
    textDecoration: 'none',
  },
  '&:active': {
    textDecoration: 'none',
  },
}));


const LocationItemLink = (props) => {
    const {listingImageFileName, pricePerDay, pricePerMonth, instantApproval, locationName, cityName, distanceTo, href = "/", target = "_self", className} = props;

    return (
        <LocationItemLinkStyles to={href} target={target} className={className}>
            <LocationItem
                listingImageFileName={listingImageFileName}
                pricePerDay={pricePerDay}
                pricePerMonth={pricePerMonth}
                instantApproval={instantApproval}
                locationName={locationName}
                cityName={cityName}
                distanceTo={distanceTo}
                width="100%"
            />
        </LocationItemLinkStyles>
    );
};

export default LocationItemLink;
